import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Directory',
    links: [
      { label: 'Browse Skills', to: '/browse' },
      { label: 'Submit a Skill', to: '/submit' },
      { label: 'Leaderboard', to: '/browse?sort=popular' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Documentation', to: '/docs' },
      { label: 'SKILL.md Format', to: '/docs#skill-format' },
      { label: 'CLI Reference', to: '/docs#cli' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Strongly.AI', to: 'https://strongly.ai', external: true },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative mt-auto">
      {/* Gradient top border */}
      <div className="h-px bg-gradient-to-r from-transparent via-brand-500/30 to-transparent" />

      <div className="bg-surface-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            {/* Brand */}
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <img src="/favicon.svg" alt="Strongly.AI" className="w-8 h-8 rounded-lg" />
                <span className="text-lg font-bold gradient-text">Skills AI</span>
              </div>
              <p className="text-sm text-slate-500 leading-relaxed">
                The open skills directory for AI coding agents.
                Discover, install, and share reusable skills.
              </p>
            </div>

            {/* Link Columns */}
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-white mb-4 tracking-wide uppercase">
                  {group.title}
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      {'external' in link && link.external ? (
                        <a
                          href={link.to}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-slate-500 hover:text-brand-400 transition-colors"
                        >
                          {link.label}
                        </a>
                      ) : (
                        <Link
                          to={link.to}
                          className="text-sm text-slate-500 hover:text-brand-400 transition-colors"
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom Bar */}
          <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-slate-600">
              Powered by{' '}
              <a
                href="https://strongly.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-brand-400 transition-colors"
              >
                Strongly.AI
              </a>
            </p>
            <p className="text-xs text-slate-600">
              Built for the AI agent ecosystem.
            </p>
          </div>

          {/* Scoring disclaimer */}
          <p className="mt-4 text-[11px] text-slate-600 leading-relaxed">
            Quality scores, risk scores, and recommendations such as "Safe to Install"
            are produced by automated heuristics for informational purposes only. They
            do not certify or guarantee that any skill is secure, functional, or fit
            for any purpose. Always review and test skills independently before use.
            See our <Link to="/terms" className="text-slate-500 hover:text-brand-400">Terms of Service</Link>.
          </p>
        </div>
      </div>
    </footer>
  );
}
